import React from 'react';
import NavBarLeft from "../../navBar/NavBarLeft.jsx";
import NavBarTop from "../../navBar/NavBarTop.jsx";
import MadeByBRB from "../dashboard/MadeByBRB.jsx";
import FutureProjectChart from "./card/FutureProjectChart.jsx";

const FutureProjects = () => (
    <main className='w-full h-screen flex justify-between'>
        <div className='w-2/12 h-full hidden lg:block'>
            <NavBarLeft/>
        </div>
        <div className='flex-1 flex flex-col relative'>
            <div className='h-16'>
                <NavBarTop/>
            </div>
            <div className={"m-8"}>
                <p className={"text-xl font-semibold"}>Zukünftige Projekte</p>
                <div className='lg:col-span-9 border rounded-md p-4 lg:pr-8 mb-5'>
                    <FutureProjectChart/>
                </div>
            </div>
            <div className='absolute pb-4 right-0 bottom-0'>
                <MadeByBRB/>
            </div>
        </div>
    </main>

);

export default FutureProjects;